import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import CardContainer from '../common/CardContainer';
import { BoldText, Text } from '../common/Text';

const OuterCard = styled(CardContainer)`
  display: flex;
  flex: 1 0 100%;
  flex-direction: column;
  align-self: stretch;
  margin: 12px 12px 20px 12px;
  background: #ffffff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  max-width: 316px;
`;

const HeaderContainer = styled.div`
  padding: 24px 19px 19px 19px;
  border: 1px solid rgba(235, 235, 235, 0.5);
  display: flex;
  justify-content: space-between;
`;

const InsurerLogo = styled.img`
  height: 24px;
`;

const HeaderText = styled(BoldText)`
  font-size: 14px;
  line-height: 17px;
  text-align: right;
  color: #413958;
`;

const BodyContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 12px 0 12px;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 18px;
`;

const Col = styled.div`
  flex: 1 0 auto;
  width: 50%;
  margin: 0 4px;
  display: inline-block;
`;

const Label = styled(Text)`
  font-size: 10px;
  line-height: 12px;
  color: #666666;
`;

const SponsorLogo = styled.img`
  height: 24px;
`;

const IpdPolicyCard = ({ policyDetails, onTap }) => (
  <OuterCard>
    <HeaderContainer>
      <div>
        <InsurerLogo src={policyDetails.insurerLogo} />
        <p className="mt-4px text-body-l font-bold text-txtlight">IPD E-Card</p>
      </div>
      <InsurerLogo src={policyDetails.tpaLogo} />
    </HeaderContainer>
    <BodyContainer>
      <Row>
        <Col>
          <Label>Member Name</Label>
          <p className="text-body-l font-semibold text-txtlight truncate">
            {policyDetails.name}
          </p>
        </Col>
        <Col>
          <Label>UHID</Label>
          <p className="text-body-l font-semibold text-txtlight truncate">
            {policyDetails.UHID}
          </p>
        </Col>
      </Row>
      <Row>
        <Col>
          <Label>Age</Label>
          <p className="text-body-l font-semibold text-txtlight truncate">
            {policyDetails.age}
          </p>
        </Col>
        <Col>
          <Label>Ecode</Label>
          <p className="text-body-l font-semibold text-txtlight truncate">
            {policyDetails.ecode}
          </p>
        </Col>
      </Row>
      <Row>
        {policyDetails.policyNumber && (
          <Col>
            <Label>Policy Number</Label>
            <p className="text-body-l font-semibold text-txtlight truncate">
              {policyDetails.policyNumber}
            </p>
          </Col>
        )}
        <Col>
          <Label>Valid Till</Label>
          <p className="text-body-l font-semibold text-txtlight truncate">
            {policyDetails.validTill}
          </p>
        </Col>
      </Row>
      <Row>
        <Col>
          <Label>Corporate Name</Label>
          <SponsorLogo src={policyDetails.sponsorLogo} />
        </Col>
        <Col>
          <div
            className="rounded-8 p-8px border border-txtsecondary-shades7 hover text-center mr-12px"
            onClick={() => {
              onTap(policyDetails.ecardUrl);
            }}
          >
            <p className="text-body-l font-semibold text-brochure truncate">
              Download Card
            </p>
          </div>
        </Col>
      </Row>
    </BodyContainer>
  </OuterCard>
);

IpdPolicyCard.propTypes = {
  onTap: PropTypes.func,
};

export default IpdPolicyCard;
